import { render, staticRenderFns } from "./TabButtons.vue?vue&type=template&id=6966f042&scoped=true&"
import script from "./TabButtons.vue?vue&type=script&lang=js&"
export * from "./TabButtons.vue?vue&type=script&lang=js&"
import style0 from "./TabButtons.vue?vue&type=style&index=0&id=6966f042&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6966f042",
  null
  
)

export default component.exports